module.exports = __webpack_public_path__ + "img/ruah.216f4b94.png";